import { CardDealtEvent } from '../../models/communication/app-events.model';
import { GameBase } from '../game-base';
import { GameFlowBase } from '../game-flow-base';

const states = ['START', 'DRAW-AND-PLACE-CARD', 'OUTCOME'] as const;

export class ClassicGameFlow extends GameFlowBase<GameBase, (typeof states)[number]> {
    protected override states = states;

    override onChanges(table?: CardDealtEvent): void {
        switch (this.getState()) {
            case 'START': {
                this.game.faceUpMessage(this.game.getFirstCardPosition());
                this.nextState();
                break;
            }

            case 'DRAW-AND-PLACE-CARD': {
                if (!table) return;

                this.game.showCard(table.cardPosition, table.card);
                this.game.showHandValue(table);

                if (table.nextCardPosition === undefined) {
                    this.nextState();
                } else {
                    this.game.faceUpMessage(table.nextCardPosition);
                }

                break;
            }

            case 'OUTCOME': {
                if (table?.outcome !== undefined) {
                    this.game.handleOutcome(table);
                }
            }
        }
    }
}
